import { EventHandlerClass } from '@/utils/events';
import { useEffect } from 'react';

export const useKeyboardShortcuts = (callback: (e: any) => void) => {
  useEffect(() => {
    const shortCutsHandler = new EventHandlerClass(document);

    // remove existing event listeners:
    shortCutsHandler.removeEventListener('keydown.digor');

    shortCutsHandler.addEventListener('keydown.digor', (e: any) => {
      callback?.(e);
    });

    return () => {
      shortCutsHandler.removeEventListener('keydown.digor');
    };
  }, []);

  return;
};
